export const getBaseUrl = (): string => {
    const urls: {[key: string]: string} = {
      'http://areadocliente.smartboxbrasil.com.br.s3-website-sa-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.smartboxbrasil.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areadocliente.smartboxbrasil.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'https://d3h1e8vtyr87vq.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.youboxselfstorage.com.br.s3-website-sa-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.guardeperto.com.br.s3-website-sa-east-1.amazonaws.com': 'https://guardeperto.cd1dyndns.com:7000/',
      'http://areadocliente.weboxstorage.com.s3-website-sa-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.anexxo.com.br.s3-website-sa-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.pitchos.com.br.s3-website-us-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areadocliente.pitchos.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'https://d141npt3myb1o4.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      'https://d1stvbtd6odqy3.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areadocliente.weboxstorage.com': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areacliente.cdsistemas.com.br': 'https://cloud134.cd1dyndns.com:5147/',
      'https://demopitchos.cdsistemas.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.megaself.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areadocliente.megaself.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'http://areadocliente.megaself.com.br.s3-website-us-east-1.amazonaws.com': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areacliente.cdsistemas.com.br': 'https://cloud134.cd1dyndns.com:5147/',
      'https://dh7xfloraq6x1.cloudfront.net': 'https://cloud134.cd1dyndns.com:5147/',
      'https://d2gkignakqdiax.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      'https://d20smlk6lxdtea.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      'https://areadocliente.bluestorage.com.br': 'https://cloud103.cd1dyndns.com:5147/',
      'http://localhost:4202': 'https://localhost:7146/',
      'https://d213uvgy8avh09.cloudfront.net': 'https://cloud103.cd1dyndns.com:5147/',
      // 'http://localhost:4202': 'https://localhost:5147/',
      'https://cloud103.cd1dyndns.com:5148': 'https://cloud103.cd1dyndns.com:5147/',
      'https://d144flfkwf1ci5.cloudfront.net': 'https://guardeperto.cd1dyndns.com:7000/',
      'https://areadocliente.guardeperto.com.br': 'https://guardeperto.cd1dyndns.com:7000/',
      'https://areadocliente.guardeaqui.com': 'https://cloud303.cd1dyndns.com:5147/',
    };
    const url = window.location.origin;
    if (urls.hasOwnProperty(url)){
        return urls[url];
    }
    const msg = 'Nenhuma configuração encontrada para a URL';
    alert(msg);
    throw new Error(msg);
};

export const getDatabase = (): string => {
  const urls: {[key: string]: string} = {
    // Ambiente de produção
    'http://areadocliente.smartboxbrasil.com.br.s3-website-sa-east-1.amazonaws.com': 'Smartbox',
    'http://areadocliente.youboxselfstorage.com.br.s3-website-sa-east-1.amazonaws.com': 'Youbox',
    'http://areadocliente.weboxstorage.com.s3-website-sa-east-1.amazonaws.com': 'WeBox',
    'https://areadocliente.weboxstorage.com': 'WeBox',
    'https://areadocliente.smartboxbrasil.com.br': 'Smartbox',
    'https://d3h1e8vtyr87vq.cloudfront.net': 'Smartbox',
    'http://areadocliente.guardeperto.com.br.s3-website-sa-east-1.amazonaws.com': 'GuardePerto',
    'http://areadocliente.smartboxbrasil.com.br': 'Smartbox',
    'http://areadocliente.anexxo.com.br.s3-website-sa-east-1.amazonaws.com': 'Anexxo',
    'http://areadocliente.pitchos.com.br.s3-website-us-east-1.amazonaws.com': 'Pitchos',
    'https://areadocliente.pitchos.com.br': 'Pitchos',
    'https://d141npt3myb1o4.cloudfront.net': 'Anexxo',
    'https://d1stvbtd6odqy3.cloudfront.net': 'Pitchos',
    'http://areacliente.cdsistemas.com.br': 'DemoSelfStorage',
    'https://demopitchos.cdsistemas.com.br': 'DemoPitchos',
    'https://areacliente.cdsistemas.com.br': 'DemoSelfStorage',
    'https://dh7xfloraq6x1.cloudfront.net': 'DemoSelfStorage',
    'https://d2gkignakqdiax.cloudfront.net': 'WeBox',
    'https://d144flfkwf1ci5.cloudfront.net': 'GuardePerto',
    'https://areadocliente.guardeperto.com.br': 'GuardePerto',

    'http://areadocliente.megaself.com.br': 'MegaSelf',
    'https://areadocliente.megaself.com.br': 'MegaSelf',
    'https://d213uvgy8avh09.cloudfront.net': 'MegaSelf',
    'http://areadocliente.megaself.com.br.s3-website-us-east-1.amazonaws.com': 'MegaSelf',

    'https://d20smlk6lxdtea.cloudfront.net': 'BlueStorage',
    'https://areadocliente.bluestorage.com.br': 'BlueStorage',

    'https://areadocliente.guardeaqui.com': 'Urban',

    // Ambiente de desenvolvimento
    'http://localhost:4202': 'WeboxCasa',
  };
  const url = window.location.origin;
  if (urls.hasOwnProperty(url)){
    return urls[url];
  }
  const msg = 'Nenhum banco de dados encontrado';
  alert(msg);
  throw new Error(msg);
};
